import {createAsyncAction} from 'typesafe-actions';
import {ExtensionType} from '../../types/Extension';
import { ActiveSessionInfo, SetWrapUpTimePayload, UpdateForwardingModelPayload } from './payloads';
import { GetAccountProductInfoPayload } from '../accountDashboard/payloads';
import { ServiceFeature } from '../../types/ServiceFeature';
import { APIErrorInterface } from '../../types';

export const getAccountPanelAccountDetails = createAsyncAction(
    'GET_ACCOUNT_PANEL_ACCOUNT_DETAILS',
    'GET_ACCOUNT_PANEL_ACCOUNT_DETAILS_SUCCESS',
    'GET_ACCOUNT_PANEL_ACCOUNT_DETAILS_FAILED',
)<undefined, ExtensionType, undefined>();

export const getLastWrapUpActiveCall = createAsyncAction(
    'GET_LAST_WRAP_UP_ACTIVE_CALL_DETAILS',
    'GET_LAST_WRAP_UP_ACTIVE_CALL_SUCCESS',
    'GET_LAST_WRAP_UP_ACTIVE_CALL_FAILED',
)<{
    i_account: number
}, ActiveSessionInfo | undefined, undefined>();

export const setWrapUpTime = createAsyncAction(
    'SET_WRAPUP_TIME',
    'SET_WRAPUP_TIME_SUCCESS',
    'SET_WRAPUP_TIME_FAILED',
)<SetWrapUpTimePayload, undefined, undefined>();

export const updateForwardingModel = createAsyncAction(
    'UPDATE_FORWARDING_MODEL_TIME',
    'UPDATE_FORWARDING_MODEL_SUCCESS',
    'UPDATE_FORWARDING_MODEL_FAILED',
)<UpdateForwardingModelPayload, undefined, undefined>();

export const getAccountDashboardServiceFeatures = createAsyncAction(
    'GET_ACCOUNT_DASHBOARD_SERVICE_FEATURE_LIST',
    'GET_ACCOUNT_DASHBOARD_SERVICE_FEATURE_LIST_SUCCESS',
    'GET_ACCOUNT_DASHBOARD_SERVICE_FEATURE_LIST_FAILED',
)<GetAccountProductInfoPayload, ServiceFeature[], APIErrorInterface>();